module.exports = __webpack_public_path__ + "img/adminlogo.7ddaab8d.png";